import { inject, Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ToastProvider } from '@core';
import { CasesApi } from '../../../infrastructure/api/cases.api';
import { CaseApprovalRequestEntity } from '../../../domain/entities/case-approval-request.entity';
import { GetApprovalRequestsQuery } from './get-approval-requests.query';
import { GetApprovalRequestsResult } from './get-approval-requests.result';

@Injectable({ providedIn: 'root' })
export class GetApprovalRequestsUseCase {
  private readonly _api = inject(CasesApi);
  private readonly _toast = inject(ToastProvider);

  public execute(query: GetApprovalRequestsQuery): Observable<GetApprovalRequestsResult> {
    return this._api.getApprovalRequests(query.caseId).pipe(
      map((dtos) => {
        const requests = dtos.map((dto) => {
          const entity = new CaseApprovalRequestEntity();
          entity.id = dto.id;
          entity.workflowStepId = dto.workflowStepId;
          entity.workflowStepName = dto.workflowStepName;
          entity.approverUserId = dto.approverUserId;
          entity.approverName = dto.approverName;
          entity.approverRole = dto.approverRole;
          entity.decision = dto.decision;
          entity.decidedAt = dto.decidedAt;
          entity.denialNotes = dto.denialNotes;
          entity.canActNow = dto.canActNow;
          return entity;
        });
        return { requests };
      }),
      catchError((error) => {
        this._toast.error(
          'Failed to load approval requests',
          'Please try again or contact support.'
        );
        return throwError(() => error);
      })
    );
  }
}
